import * as React from 'react';
import { InjectedRouter } from 'react-router';

import { withRouter } from 'app/context/Router';
import BoxBody from 'components/BoxBody';
import DialogContent from 'components/DialogContent';
// @ts-ignore
import BirthdateSelector from 'chat/components/BirthdateSelector';
// @ts-ignore
import UserActions from 'user/UserActions';
// @ts-ignore
import User from 'entities/User';
import Button from 'components/ButtonDeprecated';

import './styles/JoinInfoPageBirthdate.scss';

type Props = {
  onDone: (user: User) => void;
  onError: (error: any) => void;
  router: InjectedRouter;
  location: any;
};

type Errors = {
  birthdate: string;
  other: string;
  [key: string]: string;
};

type State = {
  birthdate: Date | null;
  errors: Partial<Errors> | null;
};

class JoinInfoPageBirthdate extends React.Component<Props, State> {
  state: State = {
    birthdate: null,
    errors: null,
  };

  onBirthdateChange = (birthdate: Date | null) => {
    this.setState({ birthdate });
  };

  canSubmit = () => {
    return !!this.state.birthdate;
  };

  submit = async () => {
    try {
      const user = await UserActions.update({ birthdate: this.state.birthdate });
      // onDone gets passed into this component via JoinInfoPage
      // but not via setup routes, so we need to manually reroute
      // the user to progress to the next step
      if (this.props.onDone) {
        this.props.onDone(user);
      } else {
        this.props.router.push(this.props.location?.state?.location ?? '/');
      }
    } catch (errorResponse) {
      this.props.onError?.(errorResponse);

      const errors: Partial<Errors> = {};

      // This is weird because we only care about a single field: birthdate, so although
      // we are storing potentially other validation errors, we are only showing the one.
      if (errorResponse?.code === 'validation_error') {
        for (const field of errorResponse['field_errors']) {
          errors[field['field_name']] = field.messages.join(', ');
        }

        // if trying to edit the birthdate then there will another type of
        // error that informs about trying to edit the birthdate, plus this
        // should accomodate any other generic errors that might be created.
      } else if (errorResponse?.error) {
        errors.other = errorResponse?.message;
      }

      this.setState({ errors });
    }
  };

  render() {
    return (
      <DialogContent
        size="small"
        className="JoinInfoPageBirthdate"
        title={'What is your birthday?'}
        subtext={'No one else will see this information.'}>
        <BoxBody divided>
          <BirthdateSelector initialDate={this.state.birthdate} onChange={this.onBirthdateChange} />

          {this.state.errors?.birthdate ? (
            <span className="JoinInfoPageBirthdate-Error">{this.state.errors?.birthdate}</span>
          ) : null}

          {this.state.errors?.other ? (
            <span className="JoinInfoPageBirthdate-Error">{this.state.errors?.other}</span>
          ) : null}

          <Button disabled={!this.canSubmit()} onClick={this.submit}>
            Save
          </Button>
        </BoxBody>
      </DialogContent>
    );
  }
}

export { JoinInfoPageBirthdate };

export default withRouter(JoinInfoPageBirthdate);
